export default "__VITE_ASSET__D$YdYtbX__"